import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M1.25 9C0.697716 9 0.25 9.44771 0.25 10C0.25 10.5523 0.697716 11 1.25 11L1.25 9ZM18.25 9L1.25 9L1.25 11L18.25 11L18.25 9Z",
        fill: "white"
      }),
      _createElementVNode("path", {
        d: "M15.25 6L19.25 10L15.25 14",
        stroke: "white",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ]))]))
}
export default { render: render }